import { PeriodMode } from '../../../enums/periodMode'
import { PeriodComparisonValue } from '../types/periodComparisonValue'

export const periodModeToComparisonValue = (mode: PeriodMode): PeriodComparisonValue => {
  switch (mode) {
    case PeriodMode.FiscalYear:
      return 'year'
    case PeriodMode.Month:
      return 'month'
    case PeriodMode.Quarter:
      return 'quarter'
    default:
      return 'period'
  }
}
